import { AxiosPromise, AxiosStatic } from "axios";
import {
  Deal,
  DealsFundraisingCapacity,
  GetDealsParams,
  ReturnCalculatorInput,
  ReturnCalculatorResponse,
  ReturnCalculatorV2Request,
  ReturnCalculatorV2Response,
  ProjectReturnsRequest,
  ReturnProjectionResponse,
} from "../types/Deal";

export const getDeal =
  (serverURL: string, appAxios: Pick<AxiosStatic, "get">) =>
  async (dealId: string): AxiosPromise<Deal> =>
    await appAxios.get(`${serverURL}/deals/${dealId}`, {
      withCredentials: true,
    });

export const getReturnCalculator =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (body: ReturnCalculatorInput): AxiosPromise<ReturnCalculatorResponse> =>
    await appAxios.post(`${serverURL}/deals/calculator/returns`, body, {
      withCredentials: true,
    });

export const getReturnCalculatorV2 =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    body: ReturnCalculatorV2Request
  ): AxiosPromise<ReturnCalculatorV2Response> =>
    await appAxios.post(`${serverURL}/deals/calculator/returns-v2`, body, {
      withCredentials: true,
    });

export const getProjectReturns =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (body: ProjectReturnsRequest): AxiosPromise<ReturnProjectionResponse> =>
    await appAxios.post(`${serverURL}/returns-calculator/project`, body, {
      withCredentials: true,
    });

export const getDeals =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (params?: GetDealsParams): AxiosPromise<Deal[]> =>
    await appAxios.get(`${serverURL}/deals`, {
      ...(params
        ? {
            params: {
              ...(params.statuses ? { status: params.statuses } : {}),
              ...(params.pageSize ? { pageSize: params.pageSize } : {}),
              ...(params.sortBy ? { sortBy: params.sortBy } : {}),
            },
          }
        : {}),
      withCredentials: true,
    });

export const getIfIsaLiveDeals =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<Deal[]> =>
    await appAxios.get(`${serverURL}/deals/if-isa/live`, {
      withCredentials: true,
    });

export const getIfIsaTransferDestinations =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<Deal[]> =>
    await appAxios.get(`${serverURL}/deals/if-isa/transfer-destinations`, {
      withCredentials: true,
    });

export const getDealsFundraisingCapacity =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (dealIds: string[]): AxiosPromise<DealsFundraisingCapacity> =>
    await appAxios.get(`${serverURL}/deals/fundraising-capacity`, {
      params: { dealIds: dealIds.join(",") },
      withCredentials: true,
    });
